var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h2', [_vm._v("文本框")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('div', {
      staticClass: "bs-example"
    }, [_c('n3-textarea', {
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("参数")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h3', [_vm._v("事件")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-textarea")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"value\"")]), _vm._v(" >")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-textarea")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("resize")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("是否支持拖动")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max-length")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("字符数限制")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("max-height")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("最大高度")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("min-height")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("-")]), _vm._v(" "), _c('td', [_vm._v("最小高度")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("名称")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("blur")]), _vm._v(" "), _c('td', [_vm._v("失焦")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("focus")]), _vm._v(" "), _c('td', [_vm._v("聚焦")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("change")]), _vm._v(" "), _c('td', [_vm._v("值变化")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("其他表单相关参数，请移步 "), _c('a', {
    attrs: {
      "href": "#n3FormDocs"
    }
  }, [_vm._v("表单验证")]), _vm._v(" 待验证组件参数")])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-cc46f128", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cc46f128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3TextareaDocs.md
// module id = 933
// module chunks = 0